import { AfterContentInit, Component, ElementRef, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { ContractDTO, CompanyDocDTO } from '../../api/plyca-dtos-v2';
import { Configuration } from '../../conf/app.constants';

@Component({
  selector: 'contractHeader',
  templateUrl: 'contractHeader.template.html'
})
export class ContractHeaderComponent implements AfterContentInit, OnInit {
  // showHeader = true;
  @Input() contractIdentifier: string;
  @Input() contract: ContractDTO;

  isCBAM: boolean;
  actualCompanyDoc: CompanyDocDTO;
  loaded = false;

  constructor(
    public plycaService: PlycaDataService,
    private elem: ElementRef,
    public configuration: Configuration,
    public translate: TranslateService
  ) {
  }
  ngOnInit(): void {
  }

  ngAfterContentInit(): void {
    this.loadInfo();
  }


  loadInfo() {
    if (this.contractIdentifier) {
      this.plycaService.get<ContractDTO>(this.configuration.CONTRACTS_SERVICE_URL, this.contractIdentifier)
        .subscribe((contract: ContractDTO) => {
          this.contract = contract;

          this.loaded = true;
        });
    }
    this.isCBAM = (this.contract && this.contract.contractClassification
      && this.contract.contractClassification && this.contract.contractClassification.complementarySystem
      && this.contract.contractClassification.complementarySystem.identifier === 'CBAM<>SISTCOMPLEMENTARIO');
    if (this.contract && this.contract.companyDoc) {
      this.contract.companyDoc.forEach(companyDoc => {
        if (companyDoc.type === 'A') {
          this.actualCompanyDoc = companyDoc;
        }
      });
    }
    this.loaded = true;
  }

  public isLoaded(): boolean {
    return this.loaded;
  }



}
